import { css } from "@emotion/react";
import { h100css } from "assets/css/dimensions";

export default [
  h100css,
  css`
    padding: 12px 0;
    box-sizing: border-box;
    text-align: center;
    overflow-x: hidden;
    text-overflow: ellipsis;
  `,
];
